export default __webpack_public_path__ + "static/media/Group Object for Journal.ecab82ce.mp4";